if (!customElements.get('blog-posts-showcase-section')) {
  customElements.define(
    'blog-posts-showcase-section',
    class BlogPostsShowcaseSection extends HTMLElement {
      connectedCallback() {
        this.grid = this.querySelector('[data-grid]');
        if (!this.grid) return;

        this.cards = Array.from(this.grid.querySelectorAll('[data-card]'));
        this.filterButtons = Array.from(this.querySelectorAll('[data-filter]'));
        this.sortSelect = this.querySelector('[data-sort]');
        this.countLabel = this.querySelector('[data-count-label]');
        this.emptyState = this.querySelector('[data-empty-state]');
        this.postLabelSingular = this.dataset.postLabelSingular || 'Post';
        this.postLabelPlural = this.dataset.postLabelPlural || 'Posts';
        this.activeFilter = 'all';
        this.activeSort = this.sortSelect?.value || 'newest';

        this.filterButtons.forEach((button) => {
          button.addEventListener('click', () => {
            this.activeFilter = button.dataset.filter || 'all';
            this.filterButtons.forEach((chip) => {
              chip.classList.toggle('is-active', chip === button);
            });
            this.apply();
          });
        });

        if (this.sortSelect) {
          this.sortSelect.addEventListener('change', () => {
            this.activeSort = this.sortSelect.value;
            this.apply();
          });
        }

        this.apply();
      }

      apply() {
        const visibleCards = this.cards
          .filter((card) => this.matchesFilter(card))
          .sort((cardA, cardB) => this.sortCards(cardA, cardB));

        visibleCards.forEach((card, index) => {
          card.hidden = false;
          card.dataset.visibleIndex = `${index}`;
          this.grid.appendChild(card);
        });

        this.cards.forEach((card) => {
          if (visibleCards.includes(card)) return;
          card.hidden = true;
          card.dataset.visibleIndex = '';
        });

        if (this.countLabel) {
          this.countLabel.textContent = `${visibleCards.length} ${
            visibleCards.length === 1 ? this.postLabelSingular : this.postLabelPlural
          }`;
        }

        if (this.emptyState) {
          this.emptyState.classList.toggle('hidden', visibleCards.length > 0);
        }
      }

      matchesFilter(card) {
        if (this.activeFilter === 'all') return true;

        const tags = (card.dataset.tags || '')
          .split(',')
          .map((tag) => tag.trim())
          .filter(Boolean);

        return tags.includes(this.activeFilter);
      }

      sortCards(cardA, cardB) {
        const dateA = Number(cardA.dataset.published || 0);
        const dateB = Number(cardB.dataset.published || 0);
        const titleA = cardA.dataset.title || '';
        const titleB = cardB.dataset.title || '';

        switch (this.activeSort) {
          case 'oldest':
            return dateA - dateB;
          case 'title-asc':
            return titleA.localeCompare(titleB);
          case 'title-desc':
            return titleB.localeCompare(titleA);
          case 'newest':
          default:
            return dateB - dateA;
        }
      }
    }
  );
}
